import { render, staticRenderFns } from "./addOrg.dialog.vue?vue&type=template&id=4666cb65&scoped=true"
import script from "./addOrg.dialog.vue?vue&type=script&lang=js"
export * from "./addOrg.dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4666cb65",
  null
  
)

export default component.exports